import React from "react";
import { VERTICAL_SHIPS } from "@/constants";

function shade(hex, amt) {
  try {
    let c = hex.replace("#", "");
    if (c.length === 3) c = c.split("").map((x) => x + x).join("");
    const num = parseInt(c, 16);
    let r = (num >> 16) + amt;
    let g = ((num >> 8) & 0xff) + amt;
    let b = (num & 0xff) + amt;
    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  } catch {
    return hex;
  }
}

const Flame = () => (
  <g className="rocket-flame">
    <path d="M32 52 C27 58 27 62 32 64 C37 62 37 58 32 52 Z" fill="#FFD166" />
    <path d="M32 52 C29 56 29 59 32 60 C35 59 35 56 32 52 Z" fill="#FF6B35" />
  </g>
);

function RocketShape({ color }) {
  return (
    <>
      <Flame />
      <path d="M32 4 C42 12 46 26 46 38 L18 38 C18 26 22 12 32 4 Z" fill={color} />
      <path d="M32 4 C37 9 40 17 41 24 L23 24 C24 17 27 9 32 4 Z" fill="#fff" opacity="0.25" />
      <circle cx="32" cy="24" r="6" fill="#0B0D1B" />
      <circle cx="32" cy="24" r="4" fill="#8CE0FF" />
      <circle cx="30" cy="22" r="1.4" fill="#fff" />
      <path d="M18 38 L10 48 L18 46 Z" fill={color} />
      <path d="M46 38 L54 48 L46 46 Z" fill={color} />
      <rect x="18" y="38" width="28" height="8" rx="3" fill={color} opacity="0.85" />
    </>
  );
}

function ShuttleShape({ color }) {
  const light = shade(color, 60);
  return (
    <>
      <Flame />
      {/* wings */}
      <path d="M32 34 L8 50 L24 50 Z" fill={light} />
      <path d="M32 34 L56 50 L40 50 Z" fill={light} />
      {/* fuselage */}
      <path d="M32 4 C40 14 42 30 42 46 L22 46 C22 30 24 14 32 4 Z" fill="#F1F5F9" />
      <path d="M32 4 C36 12 38 22 38 30 L26 30 C26 22 28 12 32 4 Z" fill={color} opacity="0.35" />
      {/* tail fin */}
      <path d="M32 20 L32 44 L38 46 L36 22 Z" fill={color} />
      <circle cx="32" cy="20" r="4.5" fill="#0B0D1B" />
      <circle cx="32" cy="20" r="3" fill="#8CE0FF" />
    </>
  );
}

function SaucerShape({ color }) {
  const dome = shade(color, 70);
  return (
    <>
      {/* glow beam */}
      <path d="M20 40 L44 40 L52 60 L12 60 Z" fill={color} opacity="0.12" />
      {/* disc */}
      <ellipse cx="32" cy="40" rx="28" ry="9" fill={color} />
      <ellipse cx="32" cy="38" rx="28" ry="8" fill={shade(color, 30)} />
      {/* dome */}
      <path d="M18 36 C18 24 46 24 46 36 Z" fill={dome} />
      <ellipse cx="32" cy="36" rx="14" ry="4" fill={shade(color, 90)} opacity="0.6" />
      <circle cx="28" cy="31" r="2.2" fill="#fff" opacity="0.8" />
      {/* lights */}
      <circle cx="16" cy="40" r="2" fill="#FFD166" />
      <circle cx="32" cy="43" r="2" fill="#FFD166" />
      <circle cx="48" cy="40" r="2" fill="#FFD166" />
    </>
  );
}

function UfoShape({ color }) {
  const dome = shade(color, 80);
  return (
    <>
      <path d="M22 40 L42 40 L48 62 L16 62 Z" fill="#8CE0FF" opacity="0.18" />
      <ellipse cx="32" cy="40" rx="26" ry="8" fill={shade(color, -20)} />
      <ellipse cx="32" cy="38" rx="26" ry="7" fill={color} />
      <path d="M20 36 C20 25 44 25 44 36 Z" fill={dome} />
      <path d="M20 36 C20 25 44 25 44 36 Z" fill="#8CE0FF" opacity="0.35" />
      <circle cx="14" cy="39" r="2.3" fill="#06D6A0" />
      <circle cx="24" cy="42" r="2.3" fill="#FF3366" />
      <circle cx="32" cy="43" r="2.3" fill="#FFD166" />
      <circle cx="40" cy="42" r="2.3" fill="#3B82F6" />
      <circle cx="50" cy="39" r="2.3" fill="#E056FD" />
    </>
  );
}

function CapsuleShape({ color }) {
  return (
    <>
      <Flame />
      {/* body */}
      <path d="M20 44 L24 16 C24 8 40 8 40 16 L44 44 Z" fill={color} />
      <path d="M24 16 C24 9 40 9 40 16 L38 24 L26 24 Z" fill="#F1F5F9" opacity="0.9" />
      {/* band */}
      <rect x="19" y="34" width="26" height="5" rx="2" fill={shade(color, -40)} />
      {/* window */}
      <circle cx="32" cy="22" r="5" fill="#0B0D1B" />
      <circle cx="32" cy="22" r="3.4" fill="#8CE0FF" />
      <circle cx="30.4" cy="20.6" r="1.1" fill="#fff" />
      {/* base */}
      <path d="M20 44 L44 44 L46 48 L18 48 Z" fill={shade(color, -30)} />
    </>
  );
}

const SHAPES = {
  rocket: RocketShape,
  shuttle: ShuttleShape,
  saucer: SaucerShape,
  ufo: UfoShape,
  capsule: CapsuleShape,
};

// Kept the export name "Rocket" for compatibility; renders any ship variant.
export default function Rocket({ color = "#00F0FF", size = 64, variant = "rocket", flame = true }) {
  const Shape = SHAPES[variant] || RocketShape;
  const vertical = VERTICAL_SHIPS.includes(variant);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className="drop-shadow-[0_0_10px_rgba(0,0,0,0.4)]"
      data-vertical={vertical ? "true" : "false"}
    >
      <Shape color={color} showFlame={flame} />
    </svg>
  );
}

export function isVerticalShip(variant) {
  return VERTICAL_SHIPS.includes(variant);
}
